module.exports = __webpack_public_path__ + "static/media/2.9e4479d1.jpg";